var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_112_185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4678 13.25L17.001 9.63047H13.6669V7.28164C13.6669 6.29141 14.1326 5.32617 15.6259 5.32617H17.1416V2.24453C17.1416 2.24453 15.7661 2 14.451 2C11.7053 2 9.91052 3.73359 9.91052 6.87187V9.63047H6.8584V13.25H9.91052V22H13.6669V13.25H16.4678Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_112_185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 20,
    fill: "white",
    transform: "translate(6 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.62bda6de7fd5f576d2f94b2b990227d5.svg";
export { ForwardRef as ReactComponent };